import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TimeRemainingPipe } from './time-remaining.pipe';

@NgModule({
    declarations: [
        TimeRemainingPipe
    ],
    exports: [
        TimeRemainingPipe
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class TimeRemainingModule {
}



// WEBPACK FOOTER //
// ./src/app/_pipes/time-remaining.module.ts